import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select", "input"]

    connect(){
    }

    // sets the selected filter method (equals, contains)
    updateInputName(e) {
        console.log("updateInputName", `q[${e.target.value}]`)
        this.inputTarget.name = `q[${e.target.value}]`
    }



}

